<button class="ca-sign-in-with-btn" type="button" (click)="login()" mat-stroked-button >
	<mat-icon svgIcon="ms"></mat-icon> &nbsp;
	{{text}}
</button>
